"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MarkerTypes_1 = require("./MarkerTypes");
var GMapsHelp = /** @class */ (function () {
    function GMapsHelp() {
    }
    GMapsHelp.createMarker = function (poi, info, map, infoWindow, callback) {
        var poiType = info.id;
        var marker = new google.maps.Marker(GMapsHelp.getMarkerOpts(poi, poiType));
        marker.addListener("click", function () {
            callback(poi, info, marker);
        });
        return marker;
    };
    GMapsHelp.getMarkerOpts = function (poi, poiType) {
        var t = GMapsHelp.getMarkerLabelUnicode(poiType);
        return {
            position: new google.maps.LatLng(poi.lat, poi.lng),
            title: poi.name,
            draggable: false,
            label: {
                fontFamily: 'Fontawesome',
                color: '#FFFFFF',
                text: t,
            },
            icon: GMapsHelp.getIcon(GMapsHelp.getMarkerColor(poiType)),
        };
    };
    GMapsHelp.getIcon = function (colorHex) {
        return {
            path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z",
            fillColor: colorHex,
            fillOpacity: 1,
            strokeWeight: 0,
            scale: 0.09,
            anchor: new google.maps.Point(200, 510),
            labelOrigin: new google.maps.Point(205, 190) //position of the label, careful! this is affected by scale
        };
    };
    GMapsHelp.getMarkerLabelUnicode = function (poiType) {
        if (poiType === MarkerTypes_1.PoiTypes.tubes)
            return '\uf239'; //fa fa-subway 
        else if (poiType === MarkerTypes_1.PoiTypes.cycles) //**
            return '\uf206'; //fa fa-bicycle 
        else if (poiType === MarkerTypes_1.PoiTypes.dlr)
            return '\uf239'; //fa fa-subway 
        else if (poiType === MarkerTypes_1.PoiTypes.trains)
            return '\uf238'; //fa fa-train 
        else if (poiType === MarkerTypes_1.PoiTypes.eCPs) //**
            return '\uf5e7'; //fas fa-charging-station //lightgreen
        else if (poiType === MarkerTypes_1.PoiTypes.parking)
            return '\uf1b9'; //'\uf540';//'\uf85b';//'\uf615';//fas fa-parking //darkblue //same as tubes
        else if (poiType === MarkerTypes_1.PoiTypes.fitness)
            return '\uf21e'; //fas fa-heartbeat //darkgreen
        else if (poiType === MarkerTypes_1.PoiTypes.greenSpaces)
            return '\uf1bb'; //fas fa-tree //green
        else if (poiType === MarkerTypes_1.PoiTypes.walks) //**
            return '\uf554'; //fas fa-walking //green //same as green spaces
        else if (poiType === MarkerTypes_1.PoiTypes.restaurants)
            return '\uf2e7'; //fa fa-utensils //red
        else if (poiType === MarkerTypes_1.PoiTypes.barsAndPubs) //erm?? try f79f
            return '\uf000'; //f57b';//fad fa-glass-cheers //purple ---faD really???? -- doesn't want to work !!!??
        else if (poiType === MarkerTypes_1.PoiTypes.lodging)
            return '\uf0fd'; //<i class="fas fa-h-square"></i> '\uf594';// '\uf562';//'\uf562';//fas fa-concierge-bell //purple
        else if (poiType === MarkerTypes_1.PoiTypes.cinemas)
            return '\uf008'; //fas fa-film //beige
        else if (poiType === MarkerTypes_1.PoiTypes.theatres) //**
            return '\uf630'; //fas fa-theater-masks //pink
        else
            return '\uf641'; //building
    };
    GMapsHelp.getMarkerColor = function (poiType) {
        if (poiType === MarkerTypes_1.PoiTypes.tubes)
            return '#0066A2'; //fa fa-subway //darkblue
        else if (poiType === MarkerTypes_1.PoiTypes.cycles)
            return '#A13336'; //fa fa-bicycle //darkred
        else if (poiType === MarkerTypes_1.PoiTypes.dlr)
            return '#89daff'; //fa fa-subway //lightblue
        else if (poiType === MarkerTypes_1.PoiTypes.trains)
            return '#FF8E7F'; //fa fa-train //lightred
        if (poiType === MarkerTypes_1.PoiTypes.eCPs)
            return '#BBF970'; //fas fa-charging-station //lightgreen
        else if (poiType === MarkerTypes_1.PoiTypes.parking)
            return '#0066A2'; //fas fa-parking //darkblue //same as tubes
        else if (poiType === MarkerTypes_1.PoiTypes.fitness)
            return '#728224'; //fas fa-heartbeat //darkgreen
        else if (poiType === MarkerTypes_1.PoiTypes.greenSpaces)
            return '#71AF26'; //fas fa-tree //green
        else if (poiType === MarkerTypes_1.PoiTypes.walks)
            return '#71AF26'; //fas fa-walking //green //same as green spaces
        else if (poiType === MarkerTypes_1.PoiTypes.restaurants)
            return '#D43E2A'; //fa fa-utensils //red
        else if (poiType === MarkerTypes_1.PoiTypes.barsAndPubs)
            return '#D152B8'; //fad fa-glass-cheers //purple ---faD really???? 
        else if (poiType === MarkerTypes_1.PoiTypes.lodging)
            return '#FFCA92'; //fas fa-concierge-bell //purple 
        else if (poiType === MarkerTypes_1.PoiTypes.cinemas)
            return '#FFCA92'; //fas fa-film //beige
        else if (poiType === MarkerTypes_1.PoiTypes.theatres)
            return '#FF91E8'; //fas fa-theater-masks //pink
        else
            return '#FFCA92'; //color_beige
    };
    GMapsHelp.zoomLevelForSitesMap = 17; //rough match to the Site display
    GMapsHelp.zoomLevelDefault = 15; //more zoomed out - should fit almost whole 850- radius on my screens
    GMapsHelp.zoomLevelDefaultStreetViewWiz = 20;
    return GMapsHelp;
}());
exports.default = GMapsHelp;
//# sourceMappingURL=GMapsHelp.js.map